import React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import { formatCurrencyNew } from 'utils/helper';
import { useSelector } from 'react-redux';

const ProductCard = ({ product }) => {
  
      const webDetails = useSelector(state => state.webDetails);
      const { websiteInfo } = webDetails;
        const variant=product?.variants && product?.variants[0]
    console.log("info", variant)
  const navigate = useNavigate();
  return (
    <Card>
      <CardMedia
        component="img"
        height="150"
        sx={{width:"100%",margin:"auto", p:2,objectFit:"contain"}}
        image={variant?.images[0]?.image||variant?.images[0]?.image_url}
      />
      <CardContent style={{paddingInline:"5px",paddingBottom:"0px"}}>
        <Typography style={{minHeight:"50px",maxHeight:"50px", textAlign:"center" }}
           >
          {_.truncate(_.trim(product.name), { length: 25 })}
        </Typography>
        <Typography fontSize={"16px"} style={{color:"#00000099"}} color="primary">
          {formatCurrencyNew(variant.price,websiteInfo?.currency_symbol)}
        </Typography>
      </CardContent>
      <CardActions sx={{justifyContent:"center"}}>
        <Button size="small" variant='outlined' color="success" onClick={() => {
          navigate(`/product/${variant.id}`)
        }}>
          View
        </Button>
      </CardActions>
    </Card>
  );
};

export default ProductCard;
